/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_SexInputs */

const en_us2_profile_row_sex = /** @type {(inputs: Profile_Row_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biological sex`)
};

const pt_br2_profile_row_sex = /** @type {(inputs: Profile_Row_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sexo biológico`)
};

const es_419_profile_row_sex = /** @type {(inputs: Profile_Row_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sexo biológico`)
};

const pt_pt2_profile_row_sex = /** @type {(inputs: Profile_Row_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sexo biológico`)
};

const fr_fr2_profile_row_sex = /** @type {(inputs: Profile_Row_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sexe biologique`)
};

const de_de2_profile_row_sex = /** @type {(inputs: Profile_Row_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biologisches Geschlecht`)
};

const it_it2_profile_row_sex = /** @type {(inputs: Profile_Row_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesso biologico`)
};

/**
* | output |
* | --- |
* | "Biological sex" |
*
* @param {Profile_Row_SexInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_sex = /** @type {((inputs?: Profile_Row_SexInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_SexInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_sex(inputs)
	if (locale === "es-419") return es_419_profile_row_sex(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_sex(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_sex(inputs)
	if (locale === "de-DE") return de_de2_profile_row_sex(inputs)
	if (locale === "it-IT") return it_it2_profile_row_sex(inputs)
	return en_us2_profile_row_sex(inputs)
});
export { profile_row_sex as "profile.row_sex" }